"use client";

import { useSearchParams } from "next/navigation";

export const useSearchParam = <T = string>(param: "panelTab"): T | null => {
  const searchParams = useSearchParams();
  const value = searchParams.get(param);

  if (!value) return null;

  return value as T;
};
